<template>
    <div>
      <div class="indexContainer">
        <el-divider class="indexTitle" v-if="val.title">
            <div class="indexTitleMain">
                <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                <h4>{{val.summary}}</h4>
            </div>
        </el-divider>
      </div>
      <div class="groupGlory">
        <div class="indexContainer bg">
          <div style="position: relative">
            <span class="card-carousel--nav__left" @click="moveCarousel(-1)" :disabled="atHeadOfList">
              <i class="el-icon-back"></i>
            </span>
            <div class="groupGloryMain" style="overflow: hidden;">
                <el-row
                  style="display: flex; transition: transform 150ms ease-out; transform: translatex(0px);"
                  :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
                    <el-col
                      :span="8"
                      v-for="(i, index2) in items"
                      :key="index2"
                      @click.native="handleClick(index2)"
                      :class="{active: index2 == isActive}"
                      style="width: 270px">
                        <div class="line"></div>
                        <p class="year">{{i.title}}</p>
                        <span class="dian">
                            <span></span>
                        </span>
                        <p class="title" style="width: 270px">{{i.summary}}</p>
                        <p class="text">{{i.content}}</p>
                    </el-col>
                </el-row>
            </div>
            <span class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList">
              <i class="el-icon-right"></i>
            </span>
          </div>
          <div class="tabs">
            <el-row>
              <el-col :xs="24" :sm="9" >
                <img :src="items[isActive].data.historys ? items[isActive].data.historys[cindex].imgUrl : ''" width="100%" />
              </el-col>
              <el-col :xs="5" :sm="4" class="tabs-nav">
                <ul>
                  <li
                    v-for="(item, i) in items[isActive].data.historys ? items[isActive].data.historys : []"
                    :key="i"
                    @click="handleChange(i)"
                    :class="{active: cindex === i}">
                    {{item.year}}
                  </li>
                </ul>
              </el-col>
              <el-col :xs="19" :sm="11">
                <p class="textyear" v-for="(v, k) in items[isActive].data.historys ? items[isActive].data.historys[cindex].content.split('\n') : []" :key="k">
                  {{v}}
                </p>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  props: {
    val: ''
  },
    data(){
        return{
          currentOffset: 0,
          windowSize: 1,
          paginationFactor: 270,
          items:[],
          isActive: 0,
          cindex: 0
        }
    },
    computed: {
      atEndOfList() {
        return this.currentOffset <= (this.paginationFactor * -1) * (this.items.length - this.windowSize);
      },
      atHeadOfList() {
        return this.currentOffset === 0;
      },
    },
    created() {
      this.items = this.val.attaches;
    },
    methods: {
        moveCarousel(direction) {
          if (direction === 1 && !this.atEndOfList) {
            this.currentOffset -= this.paginationFactor;
          } else if (direction === -1 && !this.atHeadOfList) {
            this.currentOffset += this.paginationFactor;
          }
        },
        // 上方年份切换滚动
        handleClick(index) {
          this.cindex = 0;
          this.isActive = index;
          if(this.currentOffset == 0) {
            this.currentOffset -= this.paginationFactor * index;
          } else {
            let num = index + (this.currentOffset / 270);
            this.currentOffset -= this.paginationFactor * num;
          }
        },
        // 下方年份切换选项卡
        handleChange(i) {
          this.cindex = i;
        }
    },
    watch: {
      val(val) {
          this.items = this.val.attaches;
      }
    }

}
</script>
<style lang="less" scoped>
  ul, li {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .tabs-nav {
    padding: 0 15px;
    li {
      border-radius: 5px;
      background-color: #ccc;
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 10px;
      padding: 15px 0;
      color: #999;
    }
    li.active {
      background-color: #d82b3d;
      color: #fff;
    }
  }
  .tabs {
    margin-top: 20px;
    p {
      text-align: left;
      margin: 0;
      line-height: 160%;
      font-size: 16px;
      &:hover {
        color: #d82b3d;
      }
    }
  }
.groupGlory{
    background:#f7f7f7;
    .card-carousel--nav__left, .card-carousel--nav__right  {
      position: absolute;
      top: 13px;
      background-color:#fff;
      border:1px solid #d82b3d;
      color: #d82b3d;
      width: 36px;
      height: 36px;
      line-height: 36px;
      border-radius: 50%;
      &:hover {
        cursor: pointer;
      }
    }
    .card-carousel--nav__left {
      left: 16px;
    }
    .card-carousel--nav__right {
      right: 16px;
    }
    /deep/ .el-row .el-col:hover, /deep/ .el-row .el-col.active {
      cursor: pointer;
      .dian {
        border: 1px solid #f00;
        span {
          background: #f00;
        }
      }
    }
    .groupGloryMain{
        margin: 0 70px;
        position: relative;
        .el-col{
            position: relative;
        }
        .line{
            height: 1px;
            top: 32px;
            left: 0;
            right: 0;
            position: absolute;
            border-color: inherit;
            background-color: #ccc;
        }
        .year{
            font-size: 20px;
            font-weight: 500;
            margin: 0;
        }
        .dian{
            width: 13px;
            height: 13px;
            border-radius: 30px;
            border:1px solid #d7d7d7;
            display: inline-block;
            padding: 2px;
            span{
                width: 12px;
                height: 12px;
                border-radius: 30px;
                background: #999;
                display: inline-block;
                position:relative;
                z-index: 999;
            }
        }
        .title{
            box-sizing: border-box;
            padding: 0 20px;
            // position: relative;
            text-align: center;
            font-size: 16px;
            line-height: 20px;
            overflow: hidden; /*隐藏*/
            white-space: nowrap;  /*不换行*/
            text-overflow: ellipsis;  /* 超出部分省略号 */

        }
        .text {
          font-size: 14px;
          color: #aaa;
          padding: 0 15px;
          -webkit-line-clamp:3;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
            height: 56px;
          margin: 10px;
          overflow: hidden;
        }

    }
    .textyear{
        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        padding: 0;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/item/patch27.vue